import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisibleSecondary } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import { fetchPregunta, selectPreguntasList } from "./preguntaSlice";


interface RespuestaState {
    status: string;
    error: string;
    respuestasList: any[],
    respuesta: {
        idRespuesta: number | null;
        idPregunta: number | null;
        descripcion: string | null;
        valido: number | null;
    }
}

const initialState: RespuestaState = {
    status: "idle",
    error: "",
    respuestasList: [],
    respuesta: {
        idRespuesta: null,
        idPregunta: null,
        descripcion: null,
        valido: null
    }
}

export const createModifyRespuesta = createAsyncThunk('createModifyRespuesta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const respuestaNew = selectRespuesta(state);
    const respuestaAttributes = { ...respuestaNew };
    const idsp = respuestaAttributes.idRespuesta ? 97 : 96;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...respuestaAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisibleSecondary(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    return rejectWithValue(message);
});

export const deleteRespuesta = createAsyncThunk('deleteRespuesta', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const respuestaNew = selectRespuesta(state);
    const respuestaAttributes = { ...respuestaNew }
    const idRespuesta = respuestaAttributes.idRespuesta;
    const idsp = 98;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idRespuesta }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisibleSecondary(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    return rejectWithValue(message);
});

export const marcarRespuesta = createAsyncThunk('marcarRespuesta', async ({ idEvaluacion }: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const respuestaNew = selectRespuesta(state);
    const respuestaAttributes = { ...respuestaNew }
    const idRespuesta = respuestaAttributes.idRespuesta;
    const idPregunta = respuestaAttributes.idPregunta;
    const valido = Number(!respuestaAttributes.valido);
    const idsp = 99;
    let alert: AlertInterface;

    const esCorrecta = respuestaAttributes.valido === 1 || (respuestaAttributes.valido as any) === true;
    const seVaDesmarcar = valido === 0;

    if (esCorrecta && seVaDesmarcar) {
        const preguntasList = selectPreguntasList(state);
        const preguntaActual = preguntasList.find((p: any) => p.idPregunta === idPregunta);
        const respuestasCorrectas = (preguntaActual?.respuestasList || []).filter((r: any) => r.valido === 1 || (r.valido as any) === true);

        if (respuestasCorrectas.length === 1) {
            alert = {
                title: 'Acción no permitida',
                message: 'Debe existir al menos una opción correcta. Marca otra respuesta como correcta antes de desmarcar esta.',
                data: [],
                type: 'Crimson',
                time: Date.now()
            };
            dispatch(setDataToast(alert));
            dispatch(setVisibleToast(true));
            dispatch(setLoading(false));
            setTimeout(() => {
                dispatch(setVisibleToast(false));
            }, 4000);
            return rejectWithValue('No se puede desmarcar la última opción correcta');
        }
    }

    const { result, message, data } = await getData({ idsp, idRespuesta, valido, idPregunta }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchPregunta({ idEvaluacion }));
    return rejectWithValue(message);
});

export const respuestaSlice = createSlice({
    name: 'respuesta',
    initialState,
    reducers: {
        setRespuesta: (state, action) => {
            state.respuesta = !action.payload ? initialState.respuesta : action.payload;
        },
    },

})
export const selectRespuesta = (state: RootState) => state.respuesta.respuesta;

export const { setRespuesta } = respuestaSlice.actions;

export default respuestaSlice.reducer;